import { NOTIFY_TONE_OPTIONS, NOTIFY_TONE_PC_KEY } from './constants';

let htmlAudio = null;

export function resolveNotifyTone(id) {
  return NOTIFY_TONE_OPTIONS.find(item => item.id === id) || NOTIFY_TONE_OPTIONS[0];
}

export function readNotifyToneId() {
  return resolveNotifyTone(localStorage.getItem(NOTIFY_TONE_PC_KEY)).id;
}

export function playNotifySound(toneId) {
  const tone = resolveNotifyTone(toneId || readNotifyToneId());
  if (!tone.file) return;
  try {
    if (htmlAudio) htmlAudio.pause();
    const base = (process.env.BASE_URL || './').replace(/\/?$/, '/');
    htmlAudio = new Audio(base + 'notify/' + tone.file);
    const played = htmlAudio.play();
    if (played && played.catch) played.catch(() => {});
  } catch (e) { /* 浏览器未允许自动播放 */ }
}

export function playIncomingNotifySound() {
  if (readNotifyToneId() === 'off') return;
  playNotifySound();
}
